import { type ReactNode } from 'react';

export interface GameLayoutProps {
  children: ReactNode;
}

export function GameLayout({ children }: GameLayoutProps) {
  return (
    <div
      data-testid="game-layout"
      style={{
        position: 'fixed',
        inset: 0,
        overflow: 'hidden',
        touchAction: 'none',
        userSelect: 'none',
      }}
    >
      {children}
    </div>
  );
}
